import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import LoadingContainer from 'App/components/LoadingContainer/LoadingContainer'
import { GET_LEVELS_VOUCHER } from 'graphql/queries'
import PropTypes from 'prop-types'
import UserContext from 'stores/UserStore'

import { canChangeSchoolClassesAndLevels, graphqlClient, handleGraphQLErrorsWithToast } from 'utils'
import { ROUTES } from 'utils/constants'

import { LevelsContext } from './CoordinatorRoleContexts'

// eslint-disable-next-line consistent-return
const RegisterCoordinatorRoleLevels = ({ children }) => {
  const [learningLevels, setLearningLevels] = useState(null)
  const userStore = useContext(UserContext)
  const navigate = useNavigate()
  const currentSchool = userStore.getCurrentSchool()
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    getLevels()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const getLevels = async () => {
    try {
      const {
        data: {
          school: { levels },
        },
      } = await graphqlClient().query({
        query: GET_LEVELS_VOUCHER,
        variables: {
          accessCode: (currentSchool && currentSchool.accessCode) || userStore.schoolAccessCode,
        },
      })

      setLearningLevels(levels)
    } catch (e) {
      handleGraphQLErrorsWithToast(
        e,
        'Não foi possível carregar os níveis. Tente novamente mais tarde.',
      )

      setError(e)
    } finally {
      setLoading(false)
    }
  }

  if (
    !canChangeSchoolClassesAndLevels({
      byIntegration: currentSchool?.byIntegration,
      schoolBrands: currentSchool?.brands,
      userExternalReference: userStore?.externalReference,
    })
  ) {
    window.PLURALL_ELO_TOAST_CONTAINER.addToast({
      variant: 'negative',
      text: 'Edição de dados escolares indisponível devido a integração automática, procure a escola para a alteração dos dados.',
      seconds: 10,
    })
    navigate(ROUTES.PERFIL_DADOS_ESCOLARES)
  }

  if (error) {
    navigate(ROUTES.PERFIL_DADOS_ESCOLARES)
  }

  if (learningLevels) {
    return <LevelsContext.Provider value={learningLevels}>{children}</LevelsContext.Provider>
  }

  if (loading) {
    return <LoadingContainer text='Carregando os Níveis de Ensino' fullscreen />
  }

  navigate(ROUTES.PERFIL_DADOS_ESCOLARES)
}

RegisterCoordinatorRoleLevels.propTypes = {
  children: PropTypes.node.isRequired,
}

export default RegisterCoordinatorRoleLevels
